var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9162 11.6662H12.2579L12.0245 11.4412C13.0245 10.2745 13.5412 8.68288 13.2579 6.99121C12.8662 4.67455 10.9329 2.82454 8.59955 2.54121C5.07454 2.10788 2.10788 5.07454 2.54121 8.59955C2.82454 10.9329 4.67455 12.8662 6.99121 13.2579C8.68288 13.5412 10.2745 13.0245 11.4412 12.0245L11.6662 12.2579V12.9162L15.2079 16.4579C15.5495 16.7995 16.1079 16.7995 16.4495 16.4579C16.7912 16.1162 16.7912 15.5579 16.4495 15.2162L12.9162 11.6662ZM7.91621 11.6662C5.84121 11.6662 4.16621 9.99121 4.16621 7.91621C4.16621 5.84121 5.84121 4.16621 7.91621 4.16621C9.99121 4.16621 11.6662 5.84121 11.6662 7.91621C11.6662 9.99121 9.99121 11.6662 7.91621 11.6662Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.a938e884.svg";
export { ForwardRef as ReactComponent };